import { render, staticRenderFns } from "./CoreChart-num2.vue?vue&type=template&id=14c1a390&scoped=true&"
import script from "./CoreChart-num2.vue?vue&type=script&lang=js&"
export * from "./CoreChart-num2.vue?vue&type=script&lang=js&"
import style0 from "./CoreChart-num2.vue?vue&type=style&index=0&id=14c1a390&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c1a390",
  null
  
)

export default component.exports